import { render, staticRenderFns } from "./EvaluationsHistory.vue?vue&type=template&id=217d7069&"
import script from "./EvaluationsHistory.vue?vue&type=script&lang=js&"
export * from "./EvaluationsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports